import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import styled from 'styled-components';

interface PdfViewerProps {
  url: string;
}

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer: React.FC<PdfViewerProps> = ({ url }) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const scale = 1.3;

  return (
    <DivStylePdfViewer>
      <Document 
        file={url} 
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      >
        {Array.from(new Array(numPages), (_, index) => (
          <Page key={index} pageNumber={index + 1} scale={scale}/>
        ))}
      </Document>
    </DivStylePdfViewer>
  );
};

export default PdfViewer;

export const DivStylePdfViewer = styled.div`
    display: flex;
    justify-content: center;
    height: 650px;
    width: 100%;
    background: #333333;
    padding: 10px;
    overflow: overlay
`